import { reportingDashboardConstants, commonConstants } from "../_constants";
import { apiCall } from "../_helpers";
import { appNotification } from "../_components";
import qs from "qs";

const {
  GET_ALL_REPORTS_START,
  GET_ALL_REPORTS_SUCCESS,
  GET_ALL_REPORTS_FAILED,
  VIEW_REPORT_START,
  VIEW_REPORT_SUCCESS,
  VIEW_REPORT_FAILED,
  EDIT_REPORT_START,
  EDIT_REPORT_END,
  EDIT_REPORT_SUCCESS,
  FILTER_REPORT_START,
  FILTER_REPORT_SUCCESS,
  FILTER_REPORT_FAILED,
  VIEW_UPDATED_REPORT_START,
  VIEW_UPDATED_REPORT_SUCCESS,
  VIEW_UPDATED_REPORT_FAILED,
  GET_ALL_UPDATED_REPORTS_START,
  GET_ALL_UPDATED_REPORTS_SUCCESS,
  GET_ALL_UPDATED_REPORTS_FAILED,
  GET_REPORT_COUNT_START,
  GET_REPORT_COUNT_SUCCESS,
  GET_REPORT_COUNT_FAILED,
  FILTER_COUNT_START,
  FILTER_COUNT_SUCCESS,
  FILTER_COUNT_FAILED
} = reportingDashboardConstants;

const { SUCCESSFUL_CODE, GLOBAL_LOADING_START, GLOBAL_LOADING_ENDED } =
  commonConstants;

const getAllReports = (pageNumber, pageSize = 10) => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_REPORTS_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `/api/v1/terminal/report?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    apiCall
      .get(url)
      .then((response) => {
        const { responseCode, responseMessage, count, content, success, failed, pending, unProcessed } = response.data;

        // if (!count) {
        //   const error = {
        //     errorMessage: responseMessage,
        //   };
        //   dispatch({ type: GET_ALL_REPORTS_FAILED, payload: error });
        //   dispatch({ type: GLOBAL_LOADING_ENDED });
        //   return;
        // }
        dispatch({
          type: GET_ALL_REPORTS_SUCCESS,
          payload: { content, count, success, failed, pending, unProcessed },
        });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_ALL_REPORTS_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const viewReport = (id, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: VIEW_REPORT_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `/api/v1/terminal/id/${id}`;
    apiCall
      .get(url)
      .then((response) => {
        const content = response.data;
        onSuccessCallback();
        dispatch({ type: VIEW_REPORT_SUCCESS, payload: content });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to get Report's Details",
          "error"
        );
        dispatch({ type: VIEW_REPORT_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const getFilteredReports = (pageSize, filter) => {
  return (dispatch) => {
    dispatch({ type: FILTER_REPORT_START });
    const url = `/api/v1/terminal/report?pageSize=${pageSize}`;

    const params = qs.stringify(filter);
    const finalUrl = `${url}&${params}`;
    apiCall

      .get(finalUrl)
      .then((response) => {
        const { count, content, success, pending, failed, unProcessed } = response.data;
        if (count === 0) {
          dispatch({
            type: FILTER_REPORT_SUCCESS,
            payload: { content, count },
          });
          appNotification(
            "No data found for these filter values",
            "Report not found",
            "error"
          );
          dispatch({ type: FILTER_REPORT_FAILED });
          return;
        }

        if (count > 0) {
          dispatch({
            type: FILTER_REPORT_SUCCESS,
            payload: { content, count, success, failed, pending, unProcessed },
          });
        } else {
          const error = { errorMessage: response.data.errorMessage };
          dispatch({ type: FILTER_REPORT_FAILED, payload: error });
          return;
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to filter Report",
          "error"
        );
        dispatch({ type: FILTER_REPORT_FAILED, payload });
      });
  };
};

const getAllUpdatedReports = (pageNumber, caseId, pageSize = 10) => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_UPDATED_REPORTS_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `/api/v1/terminal/update?pageNumber=${pageNumber}&pageSize=${pageSize}&caseId=${caseId}`;
    apiCall
      .get(url)
      .then((response) => {
        const { responseCode, responseMessage, count, content } = response.data;

        if (responseCode !== "00") {
          const error = {
            errorMessage: responseMessage,
          };
          dispatch({ type: GET_ALL_UPDATED_REPORTS_FAILED, payload: error });
          dispatch({ type: GLOBAL_LOADING_ENDED });
          return;
        }
        dispatch({
          type: GET_ALL_UPDATED_REPORTS_SUCCESS,
          payload: { content, count },
        });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_ALL_UPDATED_REPORTS_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const viewUpdatedReport = (terminalId, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: VIEW_UPDATED_REPORT_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `/api/v1/terminal/update?pageNumber=1&pageSize=10&terminalId=${terminalId}`;
    apiCall
      .get(url)
      .then((response) => {
        const content = response.data;
        onSuccessCallback();
        dispatch({ type: VIEW_UPDATED_REPORT_SUCCESS, payload: content });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to get Report's Details",
          "error"
        );
        dispatch({ type: VIEW_UPDATED_REPORT_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const editReport = (id, data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: EDIT_REPORT_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `/api/v1/terminal/update/${id}`;
    apiCall
      .put(url, data)
      .then((response) => {
        const { status } = response;

        if (status !== 200) {
          const data = response.response.data;
          const { responseDescription } = data;
          const error = {
            message: responseDescription,
          };

          throw new Error(error.message);
        }
        onSuccessCallback();
        dispatch({ type: EDIT_REPORT_SUCCESS });
        dispatch({ type: GLOBAL_LOADING_ENDED });

        appNotification(
          "Report has been updated successfully",
          "Report Updated",
          "success"
        );
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error} Please try again`,
        };
        dispatch({ type: EDIT_REPORT_END, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(
          payload.errorMessage,
          "Unable to update Report",
          "error"
        );
      });
  };
};

const getSummaryCount = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_REPORTS_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = "/api/v1/terminal/report/status";
    apiCall
      .get(url)
      .then((response) => {
        const { total, totalSuccess, totalFailed, totalPending, totalUnprocessed } = response.data;
        dispatch({
          type: GET_REPORT_COUNT_SUCCESS,
          payload: { total, totalSuccess, totalFailed, totalPending, totalUnprocessed },
        });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_REPORT_COUNT_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const getFilteredSummaryCount = (filter) => {
  return (dispatch) => {
    dispatch({ type: FILTER_COUNT_START });
    const url = "/api/v1/terminal/report/status";

    const params = qs.stringify(filter);
    const finalUrl = `${url}?${params}`;
    apiCall

      .get(finalUrl)
      .then((response) => {
        const {total, totalSuccess, totalFailed, totalPending, totalUnprocessed} = response.data;
        // const { successfulCount, pendingCount, failedCount, unprocessedCount } = response.data;
        if (response.status === 200) {
          dispatch({
            type: FILTER_COUNT_SUCCESS,
            payload: { total, totalSuccess, totalFailed, totalPending, totalUnprocessed },
          });
        } else {
          const error = { errorMessage: response.data.errorMessage };
          dispatch({ type: FILTER_COUNT_FAILED, payload: error });
          return;
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to filter Report",
          "error"
        );
        dispatch({ type: FILTER_REPORT_FAILED, payload });
      });
  };
};

const reportingDashboardActions = {
  getAllReports,
  getFilteredReports,
  viewReport,
  editReport,
  viewUpdatedReport,
  getAllUpdatedReports,
  getSummaryCount,
  getFilteredSummaryCount
};

export default reportingDashboardActions;
